import React, { FC } from 'react';
import { Button } from '@material-ui/core';
import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

import { Loaders } from 'components';

interface IProps extends WithStyles<typeof styles> {
  i18nKey: string;
  disabled?: boolean;
  working?: boolean;
}

const styles = (theme: Theme) =>
  createStyles({
    root: {
      marginTop: theme.spacing(2),
      width: 200,
    },
  });

const ShareButton: FC<IProps> = ({ classes, working, disabled, i18nKey }) => {
  const { t } = useTranslation();

  if (working) {
    return <Loaders.Standard height={38} />;
  }

  return (
    <Button
      type="submit"
      size="large"
      variant="contained"
      color="primary"
      className={classes.root}
      disabled={disabled}>
      {t(i18nKey)}
    </Button>
  );
};

ShareButton.defaultProps = {
  working: false,
  disabled: false,
};

export default withStyles(styles)(ShareButton);
